export class AuthResponse {
  token: string;
  refresh_token: string;
  tokenTTL: string;
  requires_2fa: boolean;
  requires_2fa_setup: boolean;
  "2fa": {
    is_enabled: boolean;
    force: boolean;
  };

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/data/model/authResponse.ts